import { extractDigits } from 'shared/utilities/digits';

export function isNewUserCompletionRequired(error) {
  if (!error || error.status !== 422) {
    return false;
  }
  const data = error.data || {};
  return data.is_new_user === true && data.next_step === 'complete_profile';
}

export function remainingAttemptsFrom(error) {
  if (!error) {
    return null;
  }
  if (error.remainingAttempts != null) {
    return error.remainingAttempts;
  }
  const data = error.data || {};
  if (data.remaining_attempts != null) {
    const value = Number(data.remaining_attempts);
    return Number.isFinite(value) ? value : null;
  }
  return null;
}

export function buildInitialVerifyPayload({ phone, code, locale }) {
  return {
    phone,
    code: extractDigits(code, 6),
    preferred_locale: locale,
    device_type: 'web',
  };
}

export {
  buildProfileCompletionPayload,
} from 'auth/profileForm';
